import {SAVE_STATE , REMOVE_STATE} from './../actions/ActionTypes';
import InitialState from './InitialState';

export default (state = InitialState.state, action) => {
    switch(action.type) {
        case SAVE_STATE :
            return Object.assign({}, action.state);

        case REMOVE_STATE : 
            return {};
        
        default : 
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/SaveStateReducer.js